import React from 'react';
import type { V1QuestionOption } from '../types/v1-questionnaire.types';

interface V1SelectQuestionProps {
  options: V1QuestionOption[];
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  hasError?: boolean;
}

export const V1SelectQuestion: React.FC<V1SelectQuestionProps> = ({
  options,
  value,
  onChange,
  onBlur,
  placeholder = 'Select an option',
  hasError = false,
}) => {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
        hasError ? 'border-red-300' : 'border-gray-300'
      }`}
    >
      <option value="">{placeholder}</option>
      {options
        .sort((a, b) => a.position - b.position)
        .map((option) => (
          <option key={option.id} value={option.id}>
            {option.text}
          </option>
        ))}
    </select>
  );
};